import { useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
// Images
import uploadImage from "../../assets/images/upload-img.png";
import ImageFilePreview from "../../components/ImageFilePreview";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import PreviewModal from "../../components/PreviewModal";

const Step5 = () => {
  const { t } = useTranslation();
  const { handleChange, handleBlur, values, touched, errors, setFieldValue } =
    useFormikContext();

  const [logoAttachment, setLogoAttachment] = useState(null);
  const [bannerAttachment, setBannerAttachment] = useState(null);
  const [previewModal, setPreviewModal] = useState({
    show: false,
    title: "",
    fileUrl: "",
    fileType: "",
  });

  // Re-initialize preview state from Formik File objects when component mounts
  useEffect(() => {
    // Logo
    const logoFile = values?.logo;
    if (logoFile instanceof File && !logoAttachment) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoAttachment(reader.result);
      };
      reader.readAsDataURL(logoFile);
    }

    // Banner
    const bannerFile = values?.bannerImage;
    if (bannerFile instanceof File && !bannerAttachment) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBannerAttachment(reader.result);
      };
      reader.readAsDataURL(bannerFile);
    }
  }, [values?.logo, values?.bannerImage]);

  const handleRemoveLogo = () => {
    setLogoAttachment(null);
    setFieldValue("logo", null);
    const fileInput = document.getElementById("fileInput1");
    if (fileInput) fileInput.value = "";
  };

  const handleRemoveBanner = () => {
    setBannerAttachment(null);
    setFieldValue("bannerImage", null);
    const fileInput = document.getElementById("fileInput2");
    if (fileInput) fileInput.value = "";
  };

  const handleViewDocument = (title, attachment, formikValue) => {
    let fileUrl = "";
    if (attachment && typeof attachment === "string") {
      fileUrl = attachment;
    } else if (formikValue instanceof File) {
      fileUrl = URL.createObjectURL(formikValue);
    } else if (typeof formikValue === "string") {
      fileUrl = formikValue;
    }

    setPreviewModal({
      show: true,
      title,
      fileUrl,
      fileType: "image",
    });
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png"];
    const allowedExtensions = [".jpg", ".jpeg", ".png"];

    const fileTypeValid = allowedTypes.includes(file.type);
    const fileExtensionValid = allowedExtensions.some((ext) =>
      file.name.toLowerCase().endsWith(ext)
    );

    if (!fileTypeValid || !fileExtensionValid) {
      toast.error(t("Invalid file type. Please select a PNG or JPG image."));
      e.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setLogoAttachment(reader.result);
    };
    reader.readAsDataURL(file);
    setFieldValue("logo", file);
  };

  const handleBannerChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png"];
    const allowedExtensions = [".jpg", ".jpeg", ".png"];

    const fileTypeValid = allowedTypes.includes(file.type);
    const fileExtensionValid = allowedExtensions.some((ext) =>
      file.name.toLowerCase().endsWith(ext)
    );

    if (!fileTypeValid || !fileExtensionValid) {
      toast.error(t("Invalid file type. Please select a PNG or JPG image."));
      e.target.value = "";
      return;
    }
    const reader = new FileReader();
    reader.onloadend = () => {
      setBannerAttachment(reader.result);
    };
    reader.readAsDataURL(file);
    setFieldValue("bannerImage", file);
  };
  return (
    <>
      <div className="upload-container d-flex align-items-center">
        <div
          className="upload-box"
          onClick={() => document.getElementById("fileInput1").click()}
        >
          {logoAttachment ? (
            <img
              src={logoAttachment}
              alt="Logo uploaded"
              style={{ width: "150px", height: "100px", objectFit: "cover" }}
            />
          ) : (
            <img src={uploadImage} alt={t("Upload Icon")} className="upload-icon" />
          )}
          <input
            type="file"
            id="fileInput1"
            style={{ display: "none" }}
            onChange={(e) => handleLogoChange(e)}
            name="logo"
            accept=".png,.jpg,.jpeg"
          />
        </div>
        <div className="upload-description ms-3">
          <p>
            {`${t(
              "Please upload store logo Will be displayed in the Offer App and dashboard"
            )} *`}
          </p>
          {values?.logo ? (
            <>
              <p className="mb-0">{t("File Uploaded Successfully")}</p>
              <div className="d-flex gap-2 flex-nowrap">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none text-nowrap"
                  style={{ padding: 0 }}
                  onClick={() =>
                    handleViewDocument(
                      t("Store Logo"),
                      logoAttachment,
                      values?.logo
                    )
                  }
                >
                  {t("View Document")}
                </button>
                <span className="text-muted">|</span>
                <button
                  type="button"
                  className="btn text-danger text-underline-none text-nowrap"
                  style={{ padding: 0 }}
                  onClick={handleRemoveLogo}
                >
                  {t("Remove Document")}
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="mb-0">{t("Maximum file size: Up to 2 MB")}</p>
              <p className="mb-0">{t("Supported format: .png, .jpg")}</p>
            </>
          )}
          <p id="fileName1" className="mt-2 text-muted"></p>
        </div>
      </div>
      {touched.logo && errors.logo && (
        <div className="text-danger">{errors.logo}</div>
      )}

      <div className="upload-container d-flex align-items-center">
        <div
          className="upload-box"
          onClick={() => document.getElementById("fileInput2").click()}
        >
          {bannerAttachment ? (
            <img
              src={bannerAttachment}
              alt="Banner uploaded"
              style={{ width: "130px", height: "100px", objectFit: "cover" }}
            />
          ) : (
            <img src={uploadImage} alt={t("Upload Icon")} className="upload-icon" />
          )}
          <input
            type="file"
            id="fileInput2"
            style={{ display: "none" }}
            onChange={(e) => handleBannerChange(e)}
            name="bannerImage"
            accept=".png,.jpg,.jpeg"
          />
        </div>
        <div className="upload-description ms-3">
          <p>
            {`${t(
              "Please upload Banner pictures to be displayed in the Offer App"
            )} *`}
          </p>
          {values?.bannerImage ? (
            <>
              <p className="mb-0">{t("File Uploaded Successfully")}</p>
              <div className="d-flex gap-2 flex-nowrap">
                <button
                  type="button"
                  className="btn btn-link text-decoration-none text-nowrap"
                  style={{ padding: 0 }}
                  onClick={() =>
                    handleViewDocument(
                      t("Banner Image"),
                      bannerAttachment,
                      values?.bannerImage
                    )
                  }
                >
                  {t("View Document")}
                </button>
                <span className="text-muted">|</span>
                <button
                  type="button"
                  className="btn text-danger text-underline-none text-nowrap"
                  style={{ padding: 0 }}
                  onClick={handleRemoveBanner}
                >
                  {t("Remove Document")}
                </button>
              </div>
            </>
          ) : (
            <>
              <p className="mb-0">{t("Maximum file size: Up to 2 MB")}</p>
              <p className="mb-0">{t("Supported format: .png, .jpg")}</p>
            </>
          )}
          <p id="fileName2" className="mt-2 text-muted"></p>
        </div>
      </div>
      {touched.bannerImage && errors.bannerImage && (
        <div className="text-danger">{errors.bannerImage}</div>
      )}
      <PreviewModal
        show={previewModal.show}
        onHide={() => setPreviewModal({ ...previewModal, show: false })}
        title={previewModal.title}
        fileUrl={previewModal.fileUrl}
        fileType={previewModal.fileType}
      />
    </>
  );
};

export default Step5;
